<picture-upload [dataId]="data.Oid"
                [reflistName]="reflistName"
                [requiredRoles]="requiredRoles"
                [defaultNewImageType]="defaultNewImageType"
                [pictureService]="projectsPicturesService">
</picture-upload>
